export const itemDetailReducer = (state, {type, payload}) => {
    console.log(payload)
    switch (type) {
        case "init":
            return payload;
        default:
            return state;
    }
}
